import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import Properties from '../components/properties/Properties';
import PropertyDetails from '../components/properties/PropertyDetails';
import Visitors from '../components/visitors/Visitors';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import PropertyEdit from '../components/properties/PropertyEdit';
import PropertyAdvance from '../components/properties/PropertyAdvance';
import CreatePropertyIndividualCost from '../components/properties/CreatePropertyIndividualCost';

const PropertiesRoutes = ({ match: { url } }) =>
    <Switch>
        <Route path={`${url}/`} exact component={Properties} />
        <ProtectedRoute rols={['manager']} path={`${url}/:property/visitors`} exact component={Visitors} />
        <ProtectedRoute rols={['manager']} path={`${url}/:property`} exact component={PropertyDetails} />
        <ProtectedRoute rols={['manager']} path={`${url}/advance/:property`} exact component={PropertyAdvance} />
        <ProtectedRoute rols={['manager']} path={`${url}/individual-costs/create/:property`} exact component={CreatePropertyIndividualCost} />
        <ProtectedRoute rols={['manager']} path={`${url}/edit/:property`} exact component={PropertyEdit} />
        <Redirect to="/errors/404" />
    </Switch>

PropertiesRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(PropertiesRoutes);